const PageKeysEnum = {
  DISCOUNT_REPORT: "DISCOUNT_REPORT",
  REFUND_TRANSACTION_REPORT: "REFUND_TRANSACTION_REPORT",
  SALES_SUMMARY_REPORT: "SALES_SUMMARY_REPORT",
  SALES_TRANSACTION_HISTORY_REPORT: "SALES_TRANSACTION_HISTORY_REPORT",
  SHIFT_RECORDS: "SHIFT_RECORDS",
  VOID_REPORT: "VOID_REPORT",
  BANK_DEPOSIT: "BANK_DEPOSIT",
  DELIVERY_LOGS: "DELIVERY_LOGS",
  EXPENSE: "EXPENSE",
  KEY_ACCOUNT: "KEY_ACCOUNT",
  PURCHASE_ORDER: "PURCHASE_ORDER",
  DETAILED_TRANSACTION_HISTORY: "DETAILED_TRANSACTION_HISTORY",
};

export default PageKeysEnum;
